import axios from "axios";

//TODO: Need to add annotation for this function once the API is ready

const optOutModalAndReqPinApi =
    "/participant-web-services/rest/partialauth/optOutModalRequestPin/:optOut";

export const optOutModalAndReqPin = async (isOptOutParams) => {
    try {
        const response = await axios.post(
            `${window.__baseApiUrl__}${optOutModalAndReqPinApi}`,
            { optOut: isOptOutParams },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log("Errororr", error);
        return error;
    }
};
